import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const dashboardCardPdfPrinter = () => {
    const { getHeader } = pdfHeaderFooter();

    const printCardReport = (title, headers, bodyData, company, subtitle = '') => {
        const doc = {
            pageSize: 'A4',
            pageMargins: [ 25, 100, 25, 80 ],
            header: getHeader(company),
            content: [
                {
                    text: title,
                    style: 'header',
                    alignment: 'center',
                    margin: [0, 0, 0, 5],
                    bold: true,
                },
                subtitle ? {
                    text: subtitle,
                    alignment: 'center',
                    margin: [0, 0, 0, 15],
                    fontSize: 10,
                    color: '#666'
                } : '',
                {
                    table: {
                        headerRows: 1,
                        widths: headers.map(h => h.width || '*'),
                        body: [
                            headers.map(h => ({ text: h.text, style: 'tableHeader', alignment: h.alignment || 'left' })),
                            ...bodyData
                        ]
                    },
                    layout: {
                        hLineWidth: function () { return 0.5; },
                        vLineWidth: function () { return 0.5; },
                        hLineColor: function () { return '#ddd'; },
                        vLineColor: function () { return '#ddd'; },
                        fillColor: function (rowIndex) {
                            return (rowIndex === 0) ? '#f3f2f7' : null;
                        }
                    }
                }
            ],
            styles: {
                header: {
                    fontSize: 18,
                },
                tableHeader: {
                    bold: true,
                    fontSize: 10,
                    color: 'black'
                }
            },
            defaultStyle: {
                fontSize: 9
            }
        };

        pdfMake.createPdf(doc).open();
    };

    return {
        printCardReport
    };
};

export default dashboardCardPdfPrinter;
